import { gql } from '@apollo/client'

export const FOURNISSEUR_FAVORI_MUTATION_ONE = gql`
  mutation FournisseurFavori($data: d4_fournisseur_favori_equipement_insert_input!) {
    insert_d4_fournisseur_favori_equipement_one(object: $data) {
      id
    }
  }
`

export const DELETE_FOURNISSEUR_MUTATION = gql`
  mutation DeleteFournisseur($id: Int!) {
    delete_d4_fournisseur_favori_equipement_by_pk(id: $id) {
      id
    }
  }
`

export const FOURNISSEUR_FAVORI_MUTATION = gql`
  mutation FournisseurFavori($data: [d4_fournisseur_favori_equipement_insert_input!]!) {
    insert_d4_fournisseur_favori_equipement(objects: $data) {
      affected_rows
      returning {
        societe_id
        equipement_id
        id
      }
    }
  }
`
